// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"4089ef3d","447":"4089ef3d","538":"4089ef3d","575":"4089ef3d"}[chunkId] + ".chunk.css";
};